/** Required by the warmup endpoint — Stargate validates it and the controller binds it. */
const EXPERIENCE_ID = 'rovo-search-page';

/** Relative so the browser sends session cookies; Stargate adds the Slauth headers. */
export const CODE_SEARCH_WARMUP_URL = '/gateway/api/devai-code-search/v1/warmup';

/**
 * Primes DevAI's per-user access caches so a later code search skips its permission resolution.
 *
 * Sends no `workspaces`/`cloudIds`, which makes DevAI warm every workspace the user can access —
 * the right default for a blind pre-warm, since callers do not have the workspace UUIDs.
 *
 * Fire-and-forget: the endpoint answers `204` with no body, and a failure just means the next
 * search pays what it pays today.
 */
export const warmUpCodeSearch = (): Promise<void> =>
	fetch(CODE_SEARCH_WARMUP_URL, {
		method: 'POST',
		headers: {
			'X-RovoDev-Xid': EXPERIENCE_ID,
		},
	})
		.then(() => undefined)
		.catch(() => {
			// Swallow — warm-up is best-effort.
		});
